module.exports = __webpack_public_path__ + "static/img/23e.6549c49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/23e.jpg
// module id = qbsz
// module chunks = 0